module.exports = __webpack_public_path__ + "static/media/qsr_active.dea17cd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/qsr_active.svg
// module id = 1097
// module chunks = 36